import { makeStyles } from '@mui/styles';

export const useForgotPasswordStyle = makeStyles((theme: any) => {
  return {
    baseStyles: {
      // backgroundColor: theme.palette.background.paper,
      borderRadius: '10px',
    },
    resetBtn: {
      marginTop: '48px !important',
      color: `${theme.palette.color.white} !important`,
      height: '48px',
      background: `linear-gradient(90deg, ${theme.palette.color.green1} 0%, ${theme.palette.color.green2} 97.14%)`,
    },
    brandStyles: {
      color: theme.palette.color.green3,
      fontSize: '24px',
      fontWeight: '600',
    },
    returnLogin: {
      marginTop: '16px !important',
      color: `${theme.palette.color.grey2} !important`,
      height: '48px !important',
      border: `1px solid ${theme.palette.color.grey3} !important`,
    },
  };
});
